{
  "auth.email_signup.email.label": "Email",
  "auth.email_signup.first_name_caption": "Vous pouvez ajouter le nom que vous préférez plus tard, via votre compte.",
  "auth.email_signup.first_name_on_driver_license.label": "Prénom figurant sur le permis de conduire",
  "auth.email_signup.firstname.required": "Prénom requis",
  "auth.email_signup.last_name_on_driver_license.label": "Nom figurant sur le permis de conduire",
  "auth.email_signup.lastname.required": "Nom requis",
  "auth.email_signup.marketing.label": "Envoyez-moi des promotions et des mises à jour par email",
  "auth.email_signup.marketing.optin_matrix_label": "Envoyez-moi des mises à jour, recommandations et offres par email",
  "auth.email_signup.sms_marketing.label": "Envoyez-moi des promotions et des mises à jour par SMS",
  "auth.email_signup.or_sign_up_with_others": "Inscription avec {#facebookLink}Facebook{/facebookLink} ou {#googleLink}Google{/googleLink}",
  "auth.email_signup.password.error_min_length": "Le mot de passe doit contenir au moins 8 caractères",
  "auth.email_signup.email.error_format": "Veuillez saisir une adresse email valide",
  "auth.email_signup.password.label": "Mot de passe",
  "auth.email_signup.sign_up": "Inscription",
  "auth.email_signup.terms_of_service.label": "J’accepte les {#termsOfServiceLink}Conditions de Service{/termsOfServiceLink} et la {#privacyPolicyLink}Politique de confidentialité{/privacyPolicyLink}.",
  "auth.email_signup.title": "Démarrer"
}
